import DateTimeFormat from "gregorian-calendar-format";

const defaultDisabledTime = {
  disabledHours() {
    return [];
  },
  disabledMinutes() {
    return [];
  },
  disabledSeconds() {
    return [];
  }
};

export function getTodayTime(value) {
  const today = value.clone();
  today.setTime(Date.now());
  return today;
}

export function getTitleString(value) {
  return `${value.getYear()}-${value.getMonth() + 1}-${value.getDayOfMonth()}`;
}

export function getTodayTimeStr(value) {
  const today = getTodayTime(value);
  return getTitleString(today);
}

export function getFormatter(format, locale) {
  if (typeof format === "string") {
    return new DateTimeFormat(format, locale.format);
  }
  return format;
}

export function syncTime(from, to) {
  to.setHourOfDay(from.getHourOfDay());
  to.setMinutes(from.getMinutes());
  to.setSeconds(from.getSeconds());
}

export function getTimeConfig(value, disabledTime) {
  let disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = {
    ...defaultDisabledTime,
    ...disabledTimeConfig
  };
  return disabledTimeConfig;
}

export function isTimeValidByConfig(value, disabledTimeConfig) {
  let invalidTime = false;
  if (value) {
    const hour = value.getHourOfDay();
    const minutes = value.getMinutes();
    const seconds = value.getSeconds();
    const disabledHours = disabledTimeConfig.disabledHours();
    if (disabledHours.indexOf(hour) === -1) {
      const disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
      if (disabledMinutes.indexOf(minutes) === -1) {
        const disabledSeconds = disabledTimeConfig.disabledSeconds(
          hour,
          minutes
        );
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }
  return !invalidTime;
}

export function isTimeValid(value, disabledTime) {
  const disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}

export function isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }
  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }
  return true;
}

export function formatOfZero(value, formatWithZero = true) {
  if (
    !formatWithZero &&
    value &&
    typeof value === "string" &&
    value.indexOf("-") > -1
  ) {
    // feat: 增是否显示数字前0处理
    // 去掉日期前的0
    const arr = value.split("-");
    const newArr = [];
    if (arr && arr.length > 0) {
      arr.map(i => {
        newArr.push(i.replace(/^0/, ""));
      });
    }
    const str = newArr.join("-");
    return str;
  }
  return value;
}

//日期格式转化
export const formatDate = (date, fmt, formatWithZero = true) => {
  fmt = fmt || "yyyy-MM-dd HH:mm:ss";
  let hour = date.getHours();
  let noonStr = "AM";
  if (hour > 12) {
    hour -= 12;
    noonStr = "PM";
  }
  const obj = {
    Y: date.getFullYear(), // 年份，注意必须用getFullYear
    y: date.getFullYear(), // 年份，注意必须用getFullYear
    M: date.getMonth() + 1, // 月份，注意是从0-11
    d: date.getDate(), // 日期
    q: Math.floor((date.getMonth() + 3) / 3), // 季度
    w: date.getDay(), // 星期，注意是0-6
    H: date.getHours(), // 24小时制
    h: hour, // 12小时制
    m: date.getMinutes(), // 分钟
    s: date.getSeconds(), // 秒
    S: date.getMilliseconds(), // 毫秒
    a: noonStr
  };
  var week = ["天", "一", "二", "三", "四", "五", "六"];
  for (var i in obj) {
    fmt = fmt.replace(new RegExp(i + "+", "g"), function(m) {
      var val = obj[i] + "";
      if (i == "a") return val;
      if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
      for (var j = 0, len = val.length; j < m.length - len; j++) {
        // val = "0" + val;
        // 增加format是否带0的处理，默认带0 (年 月 日)
        if (
          !((i == "Y" || i == "y" || i == "M" || i == "d") && !formatWithZero)
        ) {
          val = "0" + val;
        }
      }
      return m.length == 1 ? val : val.substring(val.length - m.length);
    });
  }
  return fmt;
};



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/util/index.js